import gsap from "gsap";
import CustomEase from "gsap/CustomEase";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import Flip from "gsap/Flip";
// import TextPlugin from "gsap/TextPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
// import GSDevTools from "gsap/GSDevTools";
import ScrollToPlugin from "gsap/ScrollToPlugin";
// import CSSPlugin from "gsap/CSSPlugin";
// import SplitText from "gsap/SplitText";
import "./registeredEffects";

// CSSPlugin.defaultForce3D = false;

gsap.registerPlugin(
  CustomEase,
  DrawSVGPlugin,
  Flip,
  ScrollTrigger,
  // GSDevTools
  // CSSPlugin
  // SplitText,
  // TextPlugin,
  ScrollToPlugin
);

gsap.defaults({
  duration: 2,
});

export * from "gsap";
